module.exports = __webpack_public_path__ + "img/change-password.7aa2c9bd.svg";